import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from '../_FindAnIndependantFinancialAdviser.scss'
import * as commonStyles from '../../../common/_common.scss'
import ResponsiveInputsList from '../../../common/forms/ResponsiveInputsList'
import { Form, FormCheck, Row, Col } from 'react-bootstrap'
import classNames from 'classnames'

class FinancialServices extends React.Component {
  static propTypes = {
    financialServices: PropTypes.array,
    serviceSelected: PropTypes.func.isRequired,
    selectedServices: PropTypes.array.isRequired,
    validation: PropTypes.object.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
  }

  static defaultProps = {
    financialServices: []
  }

  constructor (props) {
    super(props)
    this.onCheckedStateChanged = this.onCheckedStateChanged.bind(this)
    this.renderFinancialServiceCheckbox = this.renderFinancialServiceCheckbox.bind(this)
  }

  onCheckedStateChanged = (event) => {
    this.props.serviceSelected(parseInt(event.target.value))
  }

  render () {
    const helpBlockStyles = styles['help-block-font-size'] +
      ' ' + styles['margin-left-auto'] +
      ' ' + styles['margin-right-auto'] +
      ' ' + 'alert alert-danger'

    const financialServicesData = this.props.financialServices || []

    let financialServices = financialServicesData.map(service => ({
      ...service,
      checked: this.props.selectedServices.indexOf(service.financialServiceId) > -1
    }))

    const coreFinancialServices = financialServices
      .filter(function (element, index, array) {
        return (element.category === 'core')
      })

    const optionalFinancialServices = financialServices
      .filter(function (element, index, array) {
        return (element.category === 'optional')
      })
    return (
      <Row className={commonStyles['bg-white']}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <section id={'financialServicesContainer'} className={styles['financial-services-section']}>
            <div>
              <h3>Which of these services do you want?</h3>
              {this.props.showValidationErrors &&
                this.props.validation.help &&
                <Form.Text className={classNames(helpBlockStyles, 'text-center')}>
                  {this.props.validation.help}
                </Form.Text>}
              <Form.Group className={styles['financial-services-first-form']} >
                <ResponsiveInputsList list={coreFinancialServices} renderFunction={this.renderFinancialServiceCheckbox} />
              </Form.Group>
              <Row>
                <Col className="d-none d-sm-block" sm={1} md={2} lg={2} />
                <Col xs={12} sm={10} md={8} lg={8}>
                  <p className={styles['optional-financial-services-description']}>
                    The following services are offered by some independent financial advisers that are not neccessarily related to an investment product.
                  </p>
                </Col>
                <Col className="d-none d-sm-block" sm={1} md={2} lg={2} />
              </Row>
              <Form.Group className={styles['no-margin-bottom']}>
                <ResponsiveInputsList list={optionalFinancialServices} renderFunction={this.renderFinancialServiceCheckbox} />
              </Form.Group>
            </div>
          </section>
        </Col>
      </Row>
    )
  }

  renderFinancialServiceCheckbox ({ financialServiceId, name, description, checked }) {
    return <Form.Check 
    type="checkbox"
    checked={checked}
    value={financialServiceId}
    key={financialServiceId}
    onChange={this.onCheckedStateChanged}
    isInvalid={this.props.showValidationErrors && this.props.validation?.isInvalid}
    label={
      <>
    <span>{name}</span>
      <span className={'text-muted' + ' ' + styles['display-block']}>
        {description}
      </span>
      </>
      }>
      
    </Form.Check>
  }

}

export default withStyles(styles, commonStyles)(FinancialServices)